import BindingChangeDialog from './BindingChangeDialog.vue'

export default BindingChangeDialog
